<template>
  <div class="app-container">
    <nav class="main-nav">
      <router-link to="/">Home</router-link>
      <router-link to="/sobre">Sobre</router-link>
      <router-link to="/turbotatu">TurboTatu</router-link>
      <router-link to="/inventario-facil">Inventário Fácil</router-link>
      <router-link to="/dino-dash">Dino Dash</router-link>
      <router-link to="/doe-facil">DoeFácil</router-link>
      <router-link to="/AmazingPhotoEditor">AmazingPhotoEditor</router-link>
      <router-link to="/MeuQueridometro">MeuQueridometro</router-link>
    </nav>

    <main class="content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Estilos globais */
body {
  margin: 0;
  font-family: 'Arial', sans-serif;
}

.app-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.main-nav {
  background-color: #4CAF50;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 30px;
}

.main-nav a {
  color: white;
  text-decoration: none;
  margin-right: 20px;
  padding: 10px;
  border-radius: 3px;
  transition: background-color 0.3s;
}

.main-nav a:hover {
  background-color: #45a049;
}

.main-nav a.router-link-exact-active {
  background-color: #3d8b40;
}

.content {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
